module.exports = __webpack_public_path__ + "static/media/wellbeing-foundations@2x.dc2f9409.png";